const LOCAL_ADMIN_ORIGIN = "https://local.staging-meetgail.com:3001";

const trimSlash = (url: string | undefined): string =>
  (url ?? "").replace(/\/$/, "");

const isLocalAdminOrigin = (url: string): boolean =>
  url.startsWith(LOCAL_ADMIN_ORIGIN);

/**
 * Origin for links into the admin app.
 *
 * `NEXT_PUBLIC_GAIL_ADMIN_URL` comes from Vercel as the hosted staging/prod
 * admin host. `vercel env pull` therefore points the customer-app Admin menu
 * at admin.staging-meetgail.com even when you are on local. Prefer the local
 * origin in development so Auth0 callbacks stay on :3001.
 */
export const adminAppBaseUrl = (): string => {
  const base = trimSlash(process.env.NEXT_PUBLIC_BASE_ADMIN_URL);
  const hosted = trimSlash(process.env.NEXT_PUBLIC_GAIL_ADMIN_URL);
  if (process.env.NODE_ENV === "development") {
    if (isLocalAdminOrigin(base)) return base;
    if (isLocalAdminOrigin(hosted)) return hosted;
    return LOCAL_ADMIN_ORIGIN;
  }
  return hosted || base;
};
